// True when the primary input is touch (phones, tablets), for copy that would
// otherwise tell the user to click or drag.
export const isCoarsePointer =
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia('(pointer: coarse)').matches
